import styled, { css } from 'styled-components';
import { rem } from '@helpers/style';

export const icons = {
	alert: '\\e900',
	'angle-down': '\\e901',
	'angle-left': '\\e902',
	'angle-right': '\\e903',
	'angle-up': '\\e904',
	calendar: '\\e905',
	comment: '\\e906',
	cross: '\\e907',
	edit: '\\e908',
	'empty-list': '\\e909',
	feedback: '\\e90a',
	inbox: '\\e90b',
	logout: '\\e90c',
	menu: '\\e90d',
	notification: '\\e90e',
	orders: '\\e90f',
	report: '\\e910',
	settings: '\\e911',
	star: '\\e912',
	suggestion: '\\e913',
	survey: '\\e914',
	tick: '\\e915',
	time: '\\e916',
	user: '\\e917',
	wallet: '\\e918',
	closed: '\\e919',
	phone: '\\e91a',
	instagram: '\\e91b',
	linkedin: '\\e91c',
	telegram: '\\e91d',
	timer: '\\e91e',
	creditcard: '\\e91f',
	'quality-badge': '\\e920',
	rating: '\\e921',
	menubook: '\\e922',
	building: '\\e923',
	email: '\\e924',
	twitter: '\\e925',
	'empty-basket': '\\e926',
	basket: '\\e927',
	'tick-circle': '\\e928',
	lock: '\\e929',
};

const scale = {
	lg: css`
		${(p) => rem(22, p.theme.fontSize.base)}
	`,
	sm: css`
		${(p) => rem(16, p.theme.fontSize.base)}
	`,
};

const alignScale = {
	lg: 25,
	sm: 12,
};

const StyledIcon = styled.i`
  font-size: ${(p) =>
		p.$size ? scale[p.$size] : rem(19, p.theme.fontSize.base)};

  ${(p) =>
		p.$color &&
		css`
			color: ${p.theme.color[p.$color]};
		`};

  ${(p) =>
		p.$align &&
		css`
			position: absolute;
			top: 50%;
			transform: translateY(-50%);
			margin: 0;

			${p.$align === 'left' &&
			css`
				left: ${alignScale[p.$size] || 18}px;
			`}

			${p.$align === 'right' &&
			css`
				right: ${alignScale[p.$size] || 18}px;
			`}
		`}

  &::before {
    content: '${(p) => icons[p.$name] || ''}';
  }
`;

export default StyledIcon;
